import { hasWholePostal } from './quote';
import { clean } from './server-log';

export { clean };

// Why a customer on the Pay step was shown an error (ClickUp 869fcuav5 follow-up).
// A failed Place Order used to leave nothing behind: PostHog saw the page scroll
// and nothing else, and the server's reply was never recorded, so "they got an
// error but no message" and "was it the ZIP?" could not be answered afterwards.
//
// One PostHog event per error shown, `mtm_checkout_error`, with NOTHING
// identifying in it (no email, no name, no ZIP value; only whether the ZIP is
// there and well formed). It is PostHog only: these are counts to analyse, not
// the blocker-sensitive lines that go to www.error.log (see brevo.js).
//
// `stage` says where it came from:
//   card_token             Recurly refused the card details before any order went out
//   server                 the purchase request was answered with an error
//   network                no usable reply from the server at all
//   exception              the page itself threw while placing the order
//   three_d_secure         the bank verification step failed
//   wallet / wallet_not_ready   Apple Pay, Google Pay, PayPal or Venmo
//   duplicate_subscription the "you already have a subscription" dialog

const EVENT = 'mtm_checkout_error';

export function payErrorProps(e) {
  const country = e.country || 'US';
  const billingCountry = e.billingCountry || country;
  return {
    stage: e.stage || 'unknown',
    message: clean(e.message),
    server_message: clean(e.serverMessage),
    // Google Pay: the status Google gave when its sheet failed ('CANCELED' is a closed
    // sheet and never reaches here), and its own wording. Empty for everything else.
    status_code: clean(e.statusCode, 40),
    status_message: clean(e.statusMessage, 120),
    fields: Array.isArray(e.fields) ? e.fields.map((f) => clean(f, 40)).slice(0, 12) : [],
    http_status: Number.isFinite(e.httpStatus) ? e.httpStatus : null,
    method: e.method || 'card',
    attempt: e.attempt || 0,
    plan_code: e.planCode || '',
    country,
    billing_country: billingCountry,
    // Whether, never what.
    billing_postal_present: Boolean(String(e.billingPostal || '').trim()),
    billing_postal_valid_format: hasWholePostal(billingCountry, String(e.billingPostal || '').trim()),
    ship_postal_valid_format: hasWholePostal(country, String(e.shipPostal || '').trim()),
  };
}

// Telemetry must never break or slow a purchase: nothing here throws.
export function reportPayError(e) {
  try {
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(EVENT, payErrorProps(e));
    }
  } catch { /* never block checkout on telemetry */ }
}
